// extracted by mini-css-extract-plugin
export default {"contianer":"styles_contianer__nAu0e","logo":"styles_logo__bVUXw","animte_logo":"styles_animte_logo__YPRlE"};